var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "deal-viewer" },
    [
      _c(
        "a-tabs",
        [
          _c(
            "a-tab-pane",
            { key: "details", attrs: { tab: "Fırsat Detayları" } },
            [
              _c("div", { staticClass: "deal-sections" }, [
                _c("div", { staticClass: "deal-section" }, [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("Temel Bilgiler"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-group" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("sell"),
                        ]),
                        _vm._v(
                          "\n                                Fırsat Adı\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.deal.Deal_Name)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("linear_scale"),
                        ]),
                        _vm._v(
                          "\n                                Aşama\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.deal.Stage)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("person"),
                        ]),
                        _vm._v(
                          "\n                                Sorumlu\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.$_.get(_vm.deal, "Owner.name", ""))),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "deal-section" }, [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("İletişim Bilgileri"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-group" }, [
                    _vm.deal.Phone
                      ? _c("div", { staticClass: "field" }, [
                          _c("label", [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("phone"),
                            ]),
                            _vm._v(
                              "\n                                Telefon\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.maskPhone(_vm.deal.Phone))),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.deal.Email
                      ? _c("div", { staticClass: "field" }, [
                          _c("label", [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("email"),
                            ]),
                            _vm._v(
                              "\n                                E-posta\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.maskEmail(_vm.deal.Email))),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.deal.COUNTRY
                      ? _c("div", { staticClass: "field" }, [
                          _c("label", [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("public"),
                            ]),
                            _vm._v(
                              "\n                                Ülke\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.deal.COUNTRY)),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "deal-section" }, [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("Detay Bilgiler"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-group" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("category"),
                        ]),
                        _vm._v(
                          "\n                                Fırsat Tipi\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.deal.Deal_Type)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("event"),
                        ]),
                        _vm._v(
                          "\n                                Oluşturulma Tarihi\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.formatDate(_vm.deal.Created_Time))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("update"),
                        ]),
                        _vm._v(
                          "\n                                Son Güncelleme\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.formatDate(_vm.deal.Modified_Time))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("tag"),
                        ]),
                        _vm._v(
                          "\n                                Hasta ID\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.deal.HASTA_ID)),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "notes", attrs: { tab: "Notlar" } },
            [
              _c("DealNotes", {
                attrs: { dealId: _vm.deal.id },
                on: {
                  "connect-zoho": function ($event) {
                    return _vm.$emit("connect-zoho")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }